import fetch from "auth/FetchInterceptor";

const RecordsService = {};
const BASE_URL = "/requisition_personnel/init_form";

RecordsService.fetchRecords = () =>
    fetch({
        url: BASE_URL,
        method: "get",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
        },
    });

export default RecordsService;